<div class="kpi-container">
  <ng-container *ngFor="let bundle of bundles; let i = index">
    <div class="cardbox" [ngClass]="bundle.class" *ngIf="data">
      <div class="cardbody" *ngIf="data">
        <div class="kpi-info">
          <div fxLayout="row" *ngIf="data" class="kpititlebox">
            <span fxFlex> {{ bundle.item1.displayName | translate }} :</span>
            <span>
              {{ data[bundle.item1.name] | number }}
            </span>
          </div>

          <div fxLayout="row" class="pt-1 kpititlebox" *ngIf="bundle.item2">
            <span fxFlex> {{ bundle.item2.displayName | translate }} :</span>
            <span *ngIf="data">
              {{ data[bundle.item2.name] | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
